import moment from 'moment';

export function disabledCustomerReportDates(current: moment.Moment | undefined): boolean {
  if (current) {
    return current < moment('2021-02-18').startOf('day') || current > moment().endOf('day');
  } else {
    return false;
  }
}
